import {
  CHALLAN_WIDGET_LANDING,
  FASTAG_WIDGET_LANDING,
  HSRP_WIDGET_LANDING,
  RTO_WIDGET,
  VAS_LANDING_PAGE_WIDGETS,
} from '@components/Product/ProductWidget/constants'

export const isVasWidget = (widget: string) => VAS_LANDING_PAGE_WIDGETS.includes(widget)

export const isChallanLandingWidget = (widget: string) => widget === CHALLAN_WIDGET_LANDING

export const isFastagLandingWidget = (widget: string) => widget === FASTAG_WIDGET_LANDING

export const isHsrpLandingWidget = (widget: string) => widget === HSRP_WIDGET_LANDING

export const isRtoWidget = (widget: string) => widget === RTO_WIDGET
